
export default{
    // Serveur fournisseur de données - back-end
    host : 'https://mairie-quenne.fr/wp-json/',

    hostacf : 'https://mairie-quenne.fr/wp-json/acf/v3/',

    hostContent : 'https://mairie-quenne.fr/wp-content/',

    urlSite : 'https://mairie-quenne.fr/',

    maj_tech: '19/03/2024',
 
    /* Création */
        auth: "https://mairie-quenne.fr/wp-json/jwt-auth/v1/token",
        username: "admin",
        password: "admin"
}


// WEBPACK FOOTER //
// ./src/param/param.js